"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
// import FeedbackMessage from "../../models/feedback-message";
// import SaveNeeded from "../../models/save-needed";
const feedback_popup_1 = __importDefault(require("../common/feedback-popup"));
const popup_1 = __importDefault(require("../common/popup"));
const bottom_buttons_1 = __importDefault(require("../settings/bottom-buttons"));
class Feedback extends React.Component {
    constructor(props) {
        super(props);
        this.clear = this.clear.bind(this);
    }
    componentWillMount() {
        window.onbeforeunload = this.beforeUnload;
    }
    componentWillUnmount() {
        if (this.beforeUnload()) {
            if (!confirm('You have unsaved changes.\nAre you sure you want to leave and lose your changes?')) {
                window.history.back();
            }
        }
    }
    beforeUnload = () => {
        const { dirtyForms } = this.props;
        return (0, lodash_1.includes)(dirtyForms, true) ? 'changes' : null;
    };
    render() {
        const { saveNeeded, doSave, cancel, online, feedbackMessage } = this.props;
        return (React.createElement("div", { className: "form-feedback" },
            feedbackMessage.showFeedback && (React.createElement(feedback_popup_1.default, { onClose: this.clear, autoClose: true, type: feedbackMessage.isError ? 'negative' : 'positive' }, feedbackMessage.message)),
            saveNeeded.showSaveNeeded && (React.createElement(popup_1.default, { title: "Save Needed", message: saveNeeded.message },
                React.createElement(bottom_buttons_1.default, { id: "popup-buttons", submitting: saveNeeded.saving, onCancel: cancel, onSubmit: doSave }))),
            !online && (React.createElement(feedback_popup_1.default, { type: "negative" }, "It looks like you are offline, please check your internet connection"))));
    }
    clear() {
        const { clearAppFeedbackMessage } = this.props;
        clearAppFeedbackMessage();
    }
}
exports.default = Feedback;
